<script lang="ts">
import { Modifier, SHARP_BOOL_OPS, SHARP_CHANNELS, SHARP_COLORSPACES, SHARP_KERNELS } from "ts-media-server-url";
import { MODIFIER_TYPES } from "ts-media-server-url";
import * as MSU from "ts-media-server-url";

import { modifiers } from "./store";

import InputCheckbox from "./modifiers/InputCheckbox.svelte";
import InputColor from "./modifiers/InputColor.svelte";
import InputNumber from "./modifiers/InputNumber.svelte";
import Select from "./modifiers/Select.svelte";

import {
	SHARP_FITS,
	SHARP_POSITIONS,
	SHARP_STRATEGIES,
} from "ts-media-server-url";

let addModifierSelect: HTMLSelectElement;

function addModifier (e: Event) {
	let value = addModifierSelect.value;

	if (!value) {
		return;
	}

	const modifierKey = `${value}Modifier`;

	if (MSU[modifierKey] && typeof MSU[modifierKey] === "function") {
		const modifierFn = MSU[modifierKey];

		$modifiers = [ modifierFn(), ...$modifiers ];
	}
}

function removeModifier (index: number) {
	const newModifiers = [...$modifiers];
	newModifiers.splice(index, 1);
	$modifiers = [...newModifiers];
}

function moveModifierUp (index: number) {
	if (index > 0) {
		const newModifiers = [...$modifiers];
		const mod = newModifiers.splice(index, 1);
		newModifiers.splice(index - 1, 0, ...mod);

		$modifiers = [...newModifiers];
	}
}

function moveModifierDown (index: number) {
	if (index < $modifiers.length - 1) {
		const newModifiers = [...$modifiers];
		const mod = newModifiers.splice(index, 1);
		newModifiers.splice(index + 1, 0, ...mod);

		$modifiers = [...newModifiers];
	}
}

async function getConfig (type: string) {
	const res = await fetch(`https://media02.ogonline.nl/configs/${type}`);
	return await res.json();
}

let importError: string = "";

function isInputEvent (e: Event): e is InputEvent {
	return !!(e as InputEvent).data;
}

function importModifiers (e: Event) {
	console.log(e);
	if (isInputEvent(e)) {
		console.log("isInputEvent");
		try {
			let newModifiers = JSON.parse(e.data);
			importError = "";
			$modifiers = newModifiers;
		} catch (e) {
			importError = e.toString();
		}
	}
}
</script>

<div class="row">
	<div class="playground-modifiers">
		<h2 class="mt-3">Modifiers</h2>

		<form action="" on:submit|preventDefault={addModifier}>
			<div class="input-group mb-3">
				<select class="form-select" bind:this={addModifierSelect}>
					<option value="">Select modifier</option>
					{#each MODIFIER_TYPES as modType}
						<option>{modType}</option>
					{/each}
				</select>
				<button class="btn btn-primary" type="submit">Add</button>
			</div>
		</form>

		{#each $modifiers as modifier, index (modifier.modifier+index)}
			<div class="card text-white bg-secondary mb-3">
				<div class="card-body">
					<h3 class="card-title text-capitalize">
						{modifier.modifier}
						<div class="playground-modifiers-modifier-title-buttons">
							<button type="button" class="btn btn-sm btn-secondary" on:click={(e) => moveModifierUp(index)} disabled={index === 0}><i class="fas fa-arrow-up"></i></button>
							<button type="button" class="btn btn-sm btn-secondary" on:click={(e) => moveModifierDown(index)} disabled={index === $modifiers.length - 1}><i class="fas fa-arrow-down"></i></button>
							<button type="button" class="btn btn-sm btn-secondary" on:click={(e) => removeModifier(index)}><i class="fas fa-times"></i></button>
						</div>
					</h3>

					{#if modifier.modifier === "resize"}
					<InputNumber {index} key="width"></InputNumber>
					<InputNumber {index} key="height"></InputNumber>
					<Select {index} key="fit" options={SHARP_FITS}></Select>
					<Select {index} key="position" options={SHARP_POSITIONS}></Select>
					<Select {index} key="strategy" options={SHARP_STRATEGIES}></Select>
					<Select {index} key="kernel" options={SHARP_KERNELS}></Select>

					{:else if modifier.modifier === "extend"}
					<InputColor {index} key="background"></InputColor>
					<InputNumber {index} key="top"></InputNumber>
					<InputNumber {index} key="right"></InputNumber>
					<InputNumber {index} key="bottom"></InputNumber>
					<InputNumber {index} key="left"></InputNumber>

					{:else if modifier.modifier === "extract"}
					<InputNumber {index} key="top"></InputNumber>
					<InputNumber {index} key="left"></InputNumber>
					<InputNumber {index} key="width"></InputNumber>
					<InputNumber {index} key="height"></InputNumber>
					
					{:else if modifier.modifier === "trim"}
					<InputNumber {index} key="threshold"></InputNumber>

					{:else if modifier.modifier === "composite"}
					<Select {index} key="compositeId" options={getConfig("composites")}></Select>
					
					{:else if modifier.modifier === "rotate"}
					<InputNumber {index} key="angle"></InputNumber>
					<InputColor {index} key="background"></InputColor>
					
					{:else if modifier.modifier === "flip"}
					<InputCheckbox {index} key="flip"></InputCheckbox>
					
					{:else if modifier.modifier === "flop"}
					<InputCheckbox {index} key="flop"></InputCheckbox>
					
					{:else if modifier.modifier === "sharpen"}
					<InputNumber {index} key="sigma"></InputNumber>
					<InputNumber {index} key="flat"></InputNumber>
					<InputNumber {index} key="jagged"></InputNumber>
					
					{:else if modifier.modifier === "median"}
					<InputNumber {index} key="size"></InputNumber>
					
					{:else if modifier.modifier === "blur"}
					<InputNumber {index} key="sigma"></InputNumber>
					
					{:else if modifier.modifier === "flatten"}
					<InputColor {index} key="background"></InputColor>
					
					{:else if modifier.modifier === "gamma"}
					<InputNumber {index} key="gamma" min={1} max={3} step={.1}></InputNumber>
					
					{:else if modifier.modifier === "negate"}
					<InputCheckbox {index} key="negate"></InputCheckbox>
					
					{:else if modifier.modifier === "normalize"}
					<InputCheckbox {index} key="normalize"></InputCheckbox>

					{:else if modifier.modifier === "convolve"}
					<Select {index} key="convolveId" options={getConfig("convolves")}></Select>
					
					{:else if modifier.modifier === "threshold"}
					<InputNumber {index} key="threshold" min={0} max={255}></InputNumber>
					<InputCheckbox {index} key="grayscale"></InputCheckbox>

					{:else if modifier.modifier === "boolean"}
					<Select {index} key="booleanId" options={getConfig("booleans")}></Select>
					
					{:else if modifier.modifier === "linear"}
					<InputNumber {index} key="a" step={.1}></InputNumber>
					<InputNumber {index} key="b" step={.1}></InputNumber>

					{:else if modifier.modifier === "recomb"}
					<Select {index} key="recombId" options={getConfig("recombs")}></Select>
					
					{:else if modifier.modifier === "modulate"}
					<InputNumber {index} key="brightness" step={.1}></InputNumber>
					<InputNumber {index} key="saturation" step={.1}></InputNumber>
					<InputNumber {index} key="hue" step={1}></InputNumber>
					
					{:else if modifier.modifier === "tint"}
					<InputColor {index} key="rgb"></InputColor>
					
					{:else if modifier.modifier === "grayscale"}
					<InputCheckbox {index} key="grayscale"></InputCheckbox>
					
					{:else if modifier.modifier === "toColorspace"}
					<Select {index} key="colorspace" options={SHARP_COLORSPACES}></Select>
					
					{:else if modifier.modifier === "extractChannel"}
					<Select {index} key="channel" options={SHARP_CHANNELS}></Select>

					{:else if modifier.modifier === "joinChannel"}
					<Select {index} key="joinChannelId" options={getConfig("join-channels")}></Select>
					
					{:else if modifier.modifier === "bandbool"}
					<Select {index} key="boolOp" options={SHARP_BOOL_OPS}></Select>
					{/if}
				</div>
			</div>
		{/each}

		<h2>Import / Export</h2>
		<p class="text-muted">Paste JSON data to import</p>
		{#if importError}
		<div class="alert alert-danger">
			<p class="mb-0">{importError}</p>
		</div>
		{/if}
		<textarea class="playground-modifiers-export form-control bg-secondary border-secondary" value="{JSON.stringify($modifiers, null, "\t")}" on:input={(e) => { importModifiers(e); }} rows=10></textarea>
	</div>
</div>

<style>
.playground-modifiers-modifier-title-buttons {
	float:     right;
	font-size: 0;
}

.playground-modifiers-export {
	resize:      none;
	white-space: pre;
	overflow:    hidden;
}
</style>
